var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"focus"},[_c('h2',{staticClass:"focus__heading"},[_vm._v("Mé zaměření")]),_vm._l((_vm.focusLinks),function(item,index){return _c('FocusLink',{key:index,staticClass:"focus__link",attrs:{"item":item}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }